<div id="dvamxprint"></div>

<div class="overlay">
  <div class="recipt">
    <div class="recipt-header">
      <div class="row">
        <div class="col-md-1 paddtp0 col-sm-2">
          <img src="/assets/icons/payment.svg" class="img-responsive pay-icon" />
        </div>
        <div class="col-md-11 col-sm-10">
          <h4>{{ 'pages.createReceiptPage.oneReceipt.payment.paymentMethod' | translate }}</h4>
        </div>
      </div>
      <div class="row" *ngIf="shippments?.inbound?.length > 0">
        <div class="col-md-8 col-md-offset-1 item-box">
          <div class="row">
            <div class="col-md-2">
              <b>{{ 'common.inbound' | translate }}</b>
            </div>
            <div class="col-md-6" style="min-height:160px">
              <span>
                {{getAwbByCurrency('inbound')}}
              </span>
            </div>
            <div class="col-md-2 col-md-offset-2">
              <span>{{findTotalByCurrency('inbound') + ' ' + displayCurrency}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="shippments?.packaging?.length > 0">
        <div class="col-md-8 col-md-offset-1 item-box">
          <div class="row">
            <div class="col-md-2">
              <b>{{ 'common.packaging' | translate }}</b>
            </div>
            <div class="col-md-6" style="min-height:160px">
              <span>
                {{getAwbByCurrency('Packaging')}}
              </span>
            </div>
            <div class="col-md-2 col-md-offset-2">
              <span>{{findTotalByCurrency('packaging') + ' ' + displayCurrency}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="shippments?.outbound?.length > 0">
        <div class="col-md-8 col-md-offset-1 item-box">
          <div class="row">
            <div class="col-md-2">
              <b>{{ 'common.outbound' | translate }}</b>
            </div>
            <div class="col-md-4">
              <span>
                {{getAwbByCurrency('outbound')}}
              </span>
            </div>
            <!-- <div class="col-md-4">
              <span *ngFor="let item of shippments.outbound;i as index">{{item.Shipment.Number}}<i *ngIf="i != shippments.outbound.length">,</i> </span>
            </div> -->
            <div class="col-md-2 col-md-offset-4">
              <span>{{findTotalByCurrency('outbound') + ' ' + displayCurrency}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="shippments?.misc?.length > 0">
        <div class="col-md-8 col-md-offset-1 item-box">
          <div class="row">
            <div class="col-md-2">
              <b>{{ 'common.misc' | translate }}.</b>
            </div>
            <div class="col-md-4">
              <span *ngFor="let item of shippments.misc;i as index">{{item.category}}<i
                  *ngIf="i != shippments.outbound.length">,</i> </span>
              <!--<span>Shop and Ship fees</span>-->
            </div>
            <div class="col-md-2 col-md-offset-4">
              <span>{{findAllTotal2('misc')}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="row" *ngIf="shippments?.dropoff?.length > 0">
        <div class="col-md-8 col-md-offset-1 item-box">
          <div class="row">
            <div class="col-md-2">
              <b>{{ 'common.dropOff' | translate }}</b>
            </div>
            <div class="col-md-4">
              {{getAwbByCurrency('dropoff')}}
            </div>
            <div class="col-md-2 col-md-offset-4">
              <span>{{findTotalByCurrency('dropoff') + ' ' + displayCurrency}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-8 col-md-offset-1 total-box">
          <div class="row">
            <div class="col-md-2">
              <span>{{ 'common.total' | translate }}</span>
            </div>
            <div class="col-md-2 col-md-offset-8">
              <span>{{findAllTotal2('misc') + findTotalByCurrency('inbound') + findTotalByCurrency('outbound') +
                findTotalByCurrency('dropoff') + findTotalByCurrency('packaging')+ ' ' + displayCurrency}}</span>
            </div>
          </div>
        </div>
      </div>
      <div class="row sep-line"></div>
      <div class="row center" *ngIf="checkTotalAmount()">
        <div class="col-md-2 col-md-offset-2 col-sm-5 col-sm-offset-1 method-box {{cashSelected}}"
          (click)="selectPaymentType('cash')" data-toggle="modal" data-target="#NumPadModal">
          <span class="armx-cash pay-bg"></span>
          <b style="padding-bottom:10px">{{ 'pages.createReceiptPage.oneReceipt.payment.cash' | translate }}</b>
        </div>

        <div [class.disabled-div]="!CreaditCardEnabaled" class="col-md-2 col-sm-5 method-box {{ccSelected}}"
          (click)="!CreaditCardEnabaled ? null : selectPaymentType('cc')">
          <span *ngIf="!showRetry" class="armx-credit-card-alt pay-bg"></span>
          <b *ngIf="!showRetry">
            {{ 'pages.createReceiptPage.oneReceipt.payment.creditCard' | translate }}
          </b>

          <span *ngIf="showRetry" class="armx-cw pay-bg"></span>
          <b *ngIf="showRetry">
            {{ 'pages.createReceiptPage.oneReceipt.payment.retryPayment' | translate }}
          </b>
        </div>

        <div class="col-md-2 col-sm-5 method-box {{qrSelected}}" *ngIf="isSpotter && shippments?.inbound?.length == 1"
          (click)="selectPaymentType('qr')">
          <span class="armx-qrcode pay-bg"></span>
          <b>{{ 'pages.createReceiptPage.oneReceipt.payment.qrCode' | translate }}</b>

        </div>
      </div>

      <!--<div *ngIf="ccSelected == 'selected' && checkTotalAmount()">-->
      <div *ngIf="ccSelected == 'selected'">
        <div *ngIf="checkTotalAmount()">
          <div class="row" style="margin-top:20px">
            <div class="col-md-2 col-md-offset-2 col-sm-5">
              <b style="font-size:18px">{{ 'pages.createReceiptPage.oneReceipt.payment.creditCardInfo' | translate
                }}</b>
            </div>

          </div>
          <div class="row sep-line"></div>
          <div class="row">
            <div class="col-md-2 col-md-offset-2 col-sm-5">
              <div class="form-group">
                <label class="label-control">{{ 'pages.createReceiptPage.oneReceipt.payment.cardLast4Digits' | translate
                  }}</label>
                <input [disabled]="settings?.PaymentDeviceEnabled" type="text" class="form-control"
                  [(ngModel)]="creditCardNumber" />
                <span class="err" *ngIf="!isCreditCardNumberValid"><i class="unvalid armx - icon armx-cancel"></i> {{
                  'pages.createReceiptPage.oneReceipt.payment.invlidEntry' | translate }}</span>
              </div>
            </div>
            <div class="col-md-2 col-md-offset-2 col-sm-5">
              <div class="form-group">
                <label class="label-control">{{ 'pages.createReceiptPage.oneReceipt.payment.cardType' | translate
                  }}</label>
                <select [disabled]="disableChoosrCridt && settings?.PaymentDeviceEnabled" class="form-control"
                  [(ngModel)]="creditCardTypeId">
                  <option value="-1">{{ 'common.select' | translate }}</option>
                  <option *ngFor="let card of creditCardTypes" value="{{card.CreditCardTypeId}}">{{card.Description}}
                  </option>
                </select>
                <span class="err" *ngIf="!isCreditCardTypeIdValid"><i class="unvalid armx - icon armx-cancel"></i> {{
                  'pages.createReceiptPage.oneReceipt.payment.invlidEntry' | translate }}</span>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-2 col-md-offset-2 col-sm-5">
              <div class="form-group">
                <label class="label-control">{{ 'pages.createReceiptPage.oneReceipt.payment.terminalNumber' | translate
                  }}</label>
                <input [disabled]="settings?.PaymentDeviceEnabled" type="text" class="form-control"
                  [(ngModel)]="terminalNumber" max="50" />
                <span class="err" *ngIf="!isTrminalNumberValid"><i class="unvalid armx - icon armx-cancel"></i> {{
                  'pages.createReceiptPage.oneReceipt.payment.invlidEntry' | translate }}</span>
              </div>
            </div>
            <div class="col-md-2 col-md-offset-2 col-sm-5">
              <div class="form-group">
                <label class="label-control">{{ 'pages.createReceiptPage.oneReceipt.payment.authCode' | translate
                  }}</label>
                <input [disabled]="settings?.PaymentDeviceEnabled" type="text" class="form-control"
                  [(ngModel)]="authorizationCode" max="50" />
                <span class="err" *ngIf="!isAuthorizationCode"><i class="unvalid armx - icon armx-cancel"></i> {{
                  'pages.createReceiptPage.oneReceipt.payment.invlidEntry' | translate }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="qrSelected == 'selected'">
        <qrcode [qrdata]="qrLink" *ngIf="qrLink != ''" [width]="256" [errorCorrectionLevel]="'M'"></qrcode>
      </div>

      <div class="row checkout-group">
        <div class="col-md-4 col-md-offset-8">
          <button class="btn btn-default" (click)="previous()">{{ 'common.back' | translate }}</button>
          <button class="btn btn-primary" *ngIf="!isLastCurrency" (click)="onNextClick()" style="margin-left:20px;">
            {{ 'common.next' | translate }}
          </button>
          <button class="btn btn-default" *ngIf="paymentType == 'qr' && findAllTotal()" (click)="recheck()"
            style="margin-left:20px;">
            {{ 'pages.createReceiptPage.oneReceipt.payment.recheck' | translate }}
          </button>
          <button class="btn btn-primary"
                  [disabled]="isCheckoutButtonDisabled"
            *ngIf="(paymentType != 'qr' && isLastCurrency) || (paymentType == 'qr' && !findAllTotal())"
            (click)="checkOut()" style="margin-left:20px;">
            {{ 'pages.createReceiptPage.oneReceipt.payment.finishAndPrintReceipt' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Modal -->
<div id="NumPadModal" class="modal fade" role="dialog">
  <div class="modal-dialog modal-sm">
    <!-- Modal content-->
    <div class="modal-content">
      <div class="modal-header">
        <button type="button" class="close" data-dismiss="modal">&times;</button>
        <h3 class="modal-title">{{ 'pages.createReceiptPage.oneReceipt.payment.posNumpad' | translate }}</h3>
      </div>
      <div class="modal-body">
        <div class="container" style="width:100%">
          <div class="row">
            <div class="col-md-12">
              <div class="col-md-6 col-sm-6 col-xs-6">
                <h4><b class="red">{{ 'common.total' | translate }}</b></h4>
              </div>
              <div class="col-md-6">
                <h4><b>{{findAllTotal2('misc') + findTotalByCurrency('inbound') + findTotalByCurrency('outbound') +
                    findTotalByCurrency('dropoff') +
                    findTotalByCurrency('packaging')}}</b>&nbsp;<span>{{displayCurrency}}</span></h4>
              </div>
            </div>
            <div class="col-md-12">
              <div class="col-md-6 col-sm-6 col-xs-6">
                <h4><b class="red">{{ 'common.change' | translate }}</b></h4>
              </div>
              <div class="col-md-6">
                <h4><b class="green">{{findChange()}}</b>&nbsp;<span>{{displayCurrency}}</span></h4>
              </div>
            </div>
            <div class="col-md-12">
              <div class="from-group">
                <input class="from-control" id="payingAmmount" [(ngModel)]="payingAmount"
                  (keyup)="disableTheDot($event)" />
              </div>
            </div>
            <div class="col-md-12">
              <div class="col-md-4 col-sm-4 col-xs-4">
                <button class="btn btn-default btn-calculator" (click)="makeNumber('c')">{{
                  'pages.createReceiptPage.oneReceipt.payment.c' | translate }}</button>
              </div>
              <div class="col-md-4 col-sm-4 col-xs-4">
                <button class="btn btn-default btn-calculator" (click)="makeNumber('bk')">{{
                  'pages.createReceiptPage.oneReceipt.payment.bk' | translate }}</button>
              </div>
            </div>


            <div class="col-md-12">
              <div class="col-md-4 col-sm-4 col-xs-4">
                <button class="btn btn-default btn-calculator" (click)="makeNumber('1')">{{ 'common.1' | translate
                  }}</button>
              </div>
              <div class="col-md-4 col-sm-4 col-xs-4">
                <button class="btn btn-default btn-calculator" (click)="makeNumber('2')">{{ 'common.2' | translate
                  }}</button>
              </div>
              <div class="col-md-4 col-sm-4 col-xs-4">
                <button class="btn btn-default btn-calculator" (click)="makeNumber('3')">{{ 'common.3' | translate
                  }}</button>
              </div>
            </div>
            <div class="col-md-12">
              <div class="col-md-4 col-sm-4 col-xs-4">
                <button class="btn btn-default btn-calculator" (click)="makeNumber('4')">{{ 'common.4' | translate
                  }}</button>
              </div>
              <div class="col-md-4 col-sm-4 col-xs-4">
                <button class="btn btn-default btn-calculator" (click)="makeNumber('5')">{{ 'common.5' | translate
                  }}</button>
              </div>
              <div class="col-md-4 col-sm-4 col-xs-4">
                <button class="btn btn-default btn-calculator" (click)="makeNumber('6')">{{ 'common.6' | translate
                  }}</button>
              </div>
            </div>
            <div class="col-md-12">
              <div class="col-md-4 col-sm-4 col-xs-4">
                <button class="btn btn-default btn-calculator" (click)="makeNumber('7')">{{ 'common.7' | translate
                  }}</button>
              </div>
              <div class="col-md-4 col-sm-4 col-xs-4">
                <button class="btn btn-default btn-calculator" (click)="makeNumber('8')">{{ 'common.8' | translate
                  }}</button>
              </div>
              <div class="col-md-4 col-sm-4 col-xs-4">
                <button class="btn btn-default btn-calculator" (click)="makeNumber('9')">{{ 'common.9' | translate
                  }}</button>
              </div>
            </div>
            <div class="col-md-12">
              <div class="col-md-4 col-sm-4 col-xs-4">
                <button class="btn btn-default btn-calculator" (click)="makeNumber('0')">{{ 'common.0' | translate
                  }}</button>
              </div>
              <div class="col-md-4 col-sm-4 col-xs-4">
                <button class="btn btn-default btn-calculator {{dotDisabled}}" (click)="makeNumber('.')">.</button>
              </div>
              <div class="col-md-4 col-sm-4 col-xs-4">
                <button class="btn btn-default btn-calculator btn-ok red" data-dismiss="modal">{{ 'common.ok' |
                  translate }}</button>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</div>
